import useUrl from './helpers/useUrl.js'

/** @param {import('@nuxtjs/axios').NuxtAxiosInstance} client */
export default (client) => {
  const root = useUrl('user_promotions')
  const v4 = useUrl('v4/user_promotions')

  return {
    /** @param {Object} MarkAsSeenDTO
      * @param {Array<number>} MarkAsSeenDTO.promotion_ids
      *
      * @returns {Promise<AxiosResponse<CountNewResponse>>} */
    markAsSeen({ promotion_ids }) {
      const url = v4('seen')
      return client.post(url, { promotion_ids })
    },

    /** @returns {Promise<AxiosResponse<CountNewResponse>>} */
    countNew() {
      const url = v4('count/new')
      return client.get(url)
    },
    /**
     * @param {object} CancelBonusDTO
     * @param {string} CancelBonusDTO.promotion
     *
     * @returns {Promise<AxiosResponse<CancelBonusResponse>>}
     * */
    cancel({ promotion }) {
      const url = root('cancel')

      return client.post(url, { promotion })
    },

    /**
     * @param {object} ActivateBonusDTO
     * @param {string} ActivateBonusDTO.promotion_code
     *
     * @returns {Promise<AxiosResponse<ActivateBonusResponse>>}
     * */
    activate({ promotion_code }) {
      const url = root('manual-activation')

      return client.post(url, { promotion_code })
    },

    /**
     * @returns {Promise<AxiosResponse<CashboxResponse>>}
     * */
    cashbox() {
      const url = root('list/cashbox')

      return client.get(url)
    },

    /** INFO: Not used within project and no API documentation provided - so no idea how it works :) */
    activateCode(data) {
      const url = root('cc')
      const params = {
        'auth_key': data,
      }

      return client.get(url, { params })
    },

    /**
     * @returns {Promise<AxiosResponse<PromotionProgressResponse>>}
     * */
    getPromotionProgress() {
      const url = root('list/progress')

      return client.get(url)
    },
    getPromotionsAvailable() {
      const url = root('list/available')

      return client.get(url)
    },
    /** INFO: Not used within project and no API documentation provided - so no idea how it works :) */
    getPublicPromo() {
      const url = root('guest')

      return client.get(url)
    },

    /**
     * @returns {Promise<AxiosResponse<RegistrationBonusesResponse>>}
     * */
    getRegisterBonuses() {
      const url = root('list/registration')

      return client.get(url)
    },

    // TODO: IlliaSerbin Provide return type
    levelPromotions() {
      const url = root('list/levels')

      return client.get(url)
    },

    /**
     * @returns {Promise<AxiosResponse<CashboxResponse>>}
     * */
    profilePromotions() {
      const url = root('/list/profile')

      return client.get(url)
    },

    promotionsTrack() {
      const url = v4('/list/track')

      return client.get(url)
    },
  }
}

/** @typedef {object} CountNewResponse
  * @prop {boolean} status
  * @prop {number} count */

/**
 * @typedef {object} CancelBonusResponse
 * @property {boolean} status
 * */

/**
 * @typedef {CancelBonusResponse} ActivateBonusResponse
 * */

/** @typedef {object} CashboxResponse
 * @property {boolean} status
 * @property {object[]} promotions
 * @property {number} promotions.code
 * @property {Promotion} promotions.ru
 * @property {Promotion} promotions.ua
 * @property {string[]} promotions.reward_types
 * @property {boolean} promotions.is_welcome_pack
 * @property {boolean} promotions.is_promocode
 * @property {object} promotions.rewards
 * @property {object[]} promotions.rewards.group
 * @property {number} promotions.rewards.group.min_deposit
 * @property {string} promotions.rewards.group.name_ru
 * @property {string} promotions.rewards.group.name_ua
 * @property {string} promotions.rewards.group.icon_url
 * @property {string[]} promotions.rewards.group.promotions
 * @property {object[]} lootboxes
 * @property {number} lootboxes.id
 * @property {string} lootboxes.uuid
 * @property {string} lootboxes.name
 * @property {string} lootboxes.iconUrl
 * @property {number} lootboxes.depositAmount
 * @property {object[]} activatedPromotions
 * @property {string} activatedPromotions.code
 * @property {string} activatedPromotions.type
 * @property {string} activatedPromotions.activation_type
 * @property {boolean} activatedPromotions.is_welcome_pack
 * @property {boolean} activatedPromotions.is_promocode
 * @property {number} activatedPromotions.activation_count
 * @property {string} activatedPromotions.start_date
 * @property {string} activatedPromotions.end_date
 * @property {object} activatedPromotions.ru
 * @property {string} activatedPromotions.ru.title
 * @property {string} activatedPromotions.ru.description
 * @property {string} activatedPromotions.ru.short_description
 * @property {string} activatedPromotions.ru.description_app
 * @property {string} activatedPromotions.ru.short_description_app
 * @property {string} activatedPromotions.ru.terms
 * @property {object} activatedPromotions.ru.image
 * @property {string} activatedPromotions.ru.image.desktop
 * @property {string} activatedPromotions.ru.image.mobile
 * @property {string} activatedPromotions.ru.button1
 * @property {string} activatedPromotions.ru.button2
 * @property {string} activatedPromotions.ru.url1
 * @property {string} activatedPromotions.ru.url2
 * @property {object} activatedPromotions.ua
 * @property {string} activatedPromotions.ua.title
 * @property {string} activatedPromotions.ua.description
 * @property {string} activatedPromotions.ua.short_description
 * @property {string} activatedPromotions.ua.description_app
 * @property {string} activatedPromotions.ua.short_description_app
 * @property {string} activatedPromotions.ua.terms
 * @property {object} activatedPromotions.ua.image
 * @property {string} activatedPromotions.ua.image.desktop
 * @property {string} activatedPromotions.ua.image.mobile
 * @property {string} activatedPromotions.ua.button1
 * @property {string} activatedPromotions.ua.button2
 * @property {string} activatedPromotions.ua.url1
 * @property {string} activatedPromotions.ua.url2
 * @property {object} activatedPromotions.fs
 * @property {string} activatedPromotions.fs.name
 * @property {string} activatedPromotions.fs.term
 * @property {string} activatedPromotions.fs.icon_url
 * @property {string} activatedPromotions.fs.spins_per_day
 * @property {number} activatedPromotions.fs.bet
 * @property {} activatedPromotions.groups
 * @property {object[]} activatedPromotions.bonus
 * @property {string} activatedPromotions.bonus._id
 * @property {string} activatedPromotions.bonus.code
 * @property {number} activatedPromotions.bonus.index
 * @property {string} activatedPromotions.bonus.type
 * @property {number} activatedPromotions.bonus.amount
 * @property {number} activatedPromotions.bonus.wager_amount
 * @property {number} activatedPromotions.bonus.balance
 * @property {number} activatedPromotions.bonus.wager_balance
 * @property {number} activatedPromotions.bonus.wager_played
 * @property {string} activatedPromotions.bonus.expired_date
 * @property {number} activatedPromotions.bonus.promotion_id
 * @property {string} activatedPromotions.bonus.created_date
 * @property {object} activatedPromotions.bonus.fs
 * @property {string} activatedPromotions.bonus.fs.status
 * @property {number} activatedPromotions.bonus.fs.current_spins
 * @property {number} activatedPromotions.bonus.fs.total_spins
 * @property {number} activatedPromotions.bonus.fs.bet
 * @property {string} activatedPromotions.bonus.fs.term
 * @property {string} activatedPromotions.bonus.fs.name
 * @property {string} activatedPromotions.bonus.fs.icon_url
 * @property {null} activatedPromotions.bonus.fs.type
 * @property {string} activatedPromotions.bonus.status
 * @property {object} activatedPromotions.bonus.static
 * @property {string} activatedPromotions.bonus.static.ru
 * @property {string} activatedPromotions.bonus.static.ua
 * @property {string} activatedPromotions.bonus.static.code
 * @property {null} activatedPromotions.level_gift_info
 * @property {null} activatedPromotions.min_deposit
 */

/**
 * @typedef {object} Promotion
 * @property {string} title
 * @property {string} description
 * @property {string} short_description
 * @property {string} description_app
 * @property {string} short_description_app
 * @property {string} terms
 * @property {object} image
 * @property {string} image.desktop
 * @property {string} image.mobile
 * @property {string} button1
 * @property {string} button2
 * @property {string} url1
 * @property {string} url2
 * @property {object[]} packages
 * @property {number} packages.min_deposit
 * @property {string} packages.name
 * @property {string} packages.icon_url
 * */

/**
 * @typedef {object} PromotionProgressResponse
 * @property {boolean} status
 * @property {object[]} bonuses
 * @property {string} bonuses._id
 * @property {string} bonuses.code
 * @property {number} bonuses.index
 * @property {string} bonuses.type
 * @property {number} bonuses.amount
 * @property {number} bonuses.wager_amount
 * @property {number} bonuses.balance
 * @property {number} bonuses.wager_balance
 * @property {number} bonuses.wager_played
 * @property {string} bonuses.expired_date
 * @property {number} bonuses.promotion_id
 * @property {string} bonuses.created_date
 * @property {object} bonuses.fs
 * @property {string} bonuses.fs.status
 * @property {number} bonuses.fs.current_spins
 * @property {number} bonuses.fs.total_spins
 * @property {number} bonuses.fs.bet
 * @property {string} bonuses.fs.term
 * @property {string} bonuses.fs.name
 * @property {string} bonuses.fs.icon_url
 * @property {null} bonuses.fs.type
 * @property {string} bonuses.status
 * @property {object} bonuses.static
 * @property {string} bonuses.static.ru
 * @property {string} bonuses.static.ua
 * @property {string} bonuses.static.code
 */

/** @typedef {object} RegistrationBonusesResponse
 * @property {boolean} status
 * @property {object[]} promotions
 * @property {number} promotions.code
 * @property {string} promotions.type
 * @property {string} promotions.activation_type
 * @property {boolean} promotions.is_welcome_pack
 * @property {boolean} promotions.is_promocode
 * @property {number} promotions.activation_count
 * @property {string} promotions.start_date
 * @property {string} promotions.end_date
 * @property {object} promotions.ru
 * @property {string} promotions.ru.title
 * @property {string} promotions.ru.description
 * @property {string} promotions.ru.short_description
 * @property {string} promotions.ru.description_app
 * @property {string} promotions.ru.short_description_app
 * @property {string} promotions.ru.terms
 * @property {object} promotions.ru.image
 * @property {string} promotions.ru.image.desktop
 * @property {string} promotions.ru.image.mobile
 * @property {string} promotions.ru.button1
 * @property {string} promotions.ru.button2
 * @property {string} promotions.ru.url1
 * @property {string} promotions.ru.url2
 * @property {object[]} promotions.ru.packages
 * @property {number} promotions.ru.packages.min_deposit
 * @property {string} promotions.ru.packages.name
 * @property {string} promotions.ru.packages.icon_url
 * @property {object} promotions.ua
 * @property {string} promotions.ua.title
 * @property {string} promotions.ua.description
 * @property {string} promotions.ua.short_description
 * @property {string} promotions.ua.description_app
 * @property {string} promotions.ua.short_description_app
 * @property {string} promotions.ua.terms
 * @property {object} promotions.ua.image
 * @property {string} promotions.ua.image.desktop
 * @property {string} promotions.ua.image.mobile
 * @property {string} promotions.ua.button1
 * @property {string} promotions.ua.button2
 * @property {string} promotions.ua.url1
 * @property {string} promotions.ua.url2
 * @property {object[]} promotions.ua.packages
 * @property {number} promotions.ua.packages.min_deposit
 * @property {string} promotions.ua.packages.name
 * @property {string} promotions.ua.packages.icon_url
 * @property {object[]} promotions.groups
 * @property {number} promotions.groups.min_deposit
 * @property {string} promotions.groups.name_ru
 * @property {string} promotions.groups.name_ua
 * @property {string} promotions.groups.icon_url
 * @property {string[]} promotions.groups.promotions
 * @property {} promotions.bonus
 * @property {null} promotions.level_gift_info
 * @property {number} promotions.min_deposit
 * @property {object[]} lootboxes
 * @property {number} lootboxes.id
 * @property {string} lootboxes.uuid
 * @property {string} lootboxes.name
 * @property {string} lootboxes.iconUrl
 * @property {number} lootboxes.depositAmount
 */
